import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6e93be84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "district-closure-container" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add District-Wide Schedule Change", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "Add District-Wide Schedule Change", -1))
const _hoisted_5 = { class: "form-container" }
const _hoisted_6 = { class: "form-section" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Select District", -1))
const _hoisted_8 = { class: "district-selector" }
const _hoisted_9 = { class: "search-container" }
const _hoisted_10 = {
  key: 0,
  class: "loading-indicator"
}
const _hoisted_11 = {
  key: 0,
  class: "district-list"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 1,
  class: "no-results"
}
const _hoisted_14 = {
  key: 0,
  class: "form-section"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Closure Details", -1))
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Title*", -1))
const _hoisted_18 = {
  key: 0,
  class: "error-message"
}
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "type" }, "Type*", -1))
const _hoisted_21 = /*#__PURE__*/_createStaticVNode("<option value=\"\" data-v-6e93be84>Select a type</option><option value=\"closed\" data-v-6e93be84>Closed (Full Day)</option><option value=\"snow_day\" data-v-6e93be84>Snow Day</option><option value=\"holiday\" data-v-6e93be84>Holiday</option><option value=\"sick_day\" data-v-6e93be84>Sick Day</option><option value=\"late_start\" data-v-6e93be84>Late Start</option><option value=\"early_dismissal\" data-v-6e93be84>Early Dismissal</option>", 7)
const _hoisted_28 = [
  _hoisted_21
]
const _hoisted_29 = {
  key: 0,
  class: "error-message"
}
const _hoisted_30 = {
  key: 0,
  class: "event-type-indicator"
}
const _hoisted_31 = { class: "event-icon" }
const _hoisted_32 = { class: "event-description" }
const _hoisted_33 = {
  key: 1,
  class: "form-row"
}
const _hoisted_34 = {
  key: 0,
  class: "form-group"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startTime" }, "Start Time*", -1))
const _hoisted_36 = {
  key: 0,
  class: "error-message"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-hint" }, " The time when school will start (later than usual) ", -1))
const _hoisted_38 = {
  key: 1,
  class: "form-group"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "endTime" }, "Dismissal Time*", -1))
const _hoisted_40 = {
  key: 0,
  class: "error-message"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-hint" }, " The time when school will end (earlier than usual) ", -1))
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "description" }, "Description", -1))
const _hoisted_44 = { class: "form-row" }
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startDate" }, "Start Date*", -1))
const _hoisted_47 = {
  key: 0,
  class: "error-message"
}
const _hoisted_48 = { class: "form-group" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "endDate" }, "End Date", -1))
const _hoisted_50 = ["min"]
const _hoisted_51 = {
  key: 0,
  class: "error-message"
}
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = { class: "checkbox-group" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "affectsAttendance" }, "Affects Attendance", -1))
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = { class: "checkbox-group" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "skipExistingClosures" }, "Skip schools that already have closures on these dates", -1))
const _hoisted_58 = {
  key: 1,
  class: "form-section"
}
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Apply To", -1))
const _hoisted_60 = { class: "radio-group" }
const _hoisted_61 = { class: "radio-option" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "allCalendars" }, "All active school calendars", -1))
const _hoisted_63 = { class: "radio-option" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "specificYear" }, "Only calendars for specific academic year", -1))
const _hoisted_65 = {
  key: 0,
  class: "form-group"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "academicYear" }, "Academic Year", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select academic year", -1))
const _hoisted_68 = ["value"]
const _hoisted_69 = {
  key: 0,
  class: "error-message"
}
const _hoisted_70 = { class: "form-actions" }
const _hoisted_71 = ["disabled"]
const _hoisted_72 = {
  key: 0,
  class: "success-message"
}
const _hoisted_73 = {
  key: 1,
  class: "error-message-global"
}

import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { API_URL } from "../config";
import type { OrganizationRecord } from "../types";

interface District {
  id: number;
  name: string;
  organizations?: OrganizationRecord[];
}

interface ClosureDetails {
  title: string;
  type: string;
  description: string;
  startDate: string;
  endDate: string;
  startTime?: string;
  endTime?: string;
  affectsAttendance: boolean;
}

interface Options {
  skipExistingClosures: boolean;
  applyTo: "all" | "specificYear";
  academicYear?: string;
}

interface ClosureRequestOptions {
  skipExistingClosures: boolean;
  academicYear?: string;
}

interface FormErrors {
  district?: string;
  title?: string;
  type?: string;
  startDate?: string;
  endDate?: string;
  startTime?: string;
  endTime?: string;
  academicYear?: string;
  submit?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DistrictClosureView',
  setup(__props) {

const router = useRouter();

// State variables
const districts = ref<District[]>([]);
const filteredDistricts = ref<District[]>([]);
const selectedDistrict = ref<District | null>(null);
const districtSearch = ref("");
const isLoadingDistricts = ref(true);
const isSubmitting = ref(false);
const successMessage = ref("");
const errors = ref<FormErrors>({});

// Computed property to determine if time fields should be shown
const showTimeFields = computed(() => {
  return (
    closureDetails.value.type === "late_start" ||
    closureDetails.value.type === "early_dismissal"
  );
});

// Current year and past/future years for academic year selection
const currentYear = new Date().getFullYear();
const academicYears = [
  `${currentYear - 1}-${currentYear}`,
  `${currentYear}-${currentYear + 1}`,
  `${currentYear + 1}-${currentYear + 2}`,
];

// Form data
const closureDetails = ref<ClosureDetails>({
  title: "",
  type: "",
  description: "",
  startDate: "",
  endDate: "",
  startTime: "",
  endTime: "",
  affectsAttendance: true,
});

const options = ref<Options>({
  skipExistingClosures: true,
  applyTo: "all", // 'all' or 'specificYear'
  academicYear: "",
});

// Helper functions for event type visualization
const getEventTypeIcon = (type: string) => {
  switch (type) {
    case "closed":
      return "ban";
    case "snow_day":
      return "snowflake";
    case "holiday":
      return "calendar-alt";
    case "sick_day":
      return "user-check";
    case "late_start":
      return "hourglass-half";
    case "early_dismissal":
      return "hourglass-end";
    default:
      return "calendar-day";
  }
};

const getEventTypeLabel = (type: string) => {
  switch (type) {
    case "closed":
      return "School Closed";
    case "snow_day":
      return "Snow Day";
    case "holiday":
      return "Holiday";
    case "sick_day":
      return "Sick Day";
    case "late_start":
      return "Late Start";
    case "early_dismissal":
      return "Early Dismissal";
    default:
      return "Event";
  }
};

const getEventTypeDescription = (type: string) => {
  switch (type) {
    case "closed":
      return "School will be closed for the entire day.";
    case "snow_day":
      return "School will be closed due to inclement weather.";
    case "holiday":
      return "School will be closed for a holiday.";
    case "sick_day":
      return "School will be closed due to illness.";
    case "late_start":
      return "School will start later than usual. Please specify the start time.";
    case "early_dismissal":
      return "School will end earlier than usual. Please specify the dismissal time.";
    default:
      return "Please provide details for this event.";
  }
};

// Handle type change to set default title if empty
const handleTypeChange = () => {
  // Clear time fields when type changes
  closureDetails.value.startTime = "";
  closureDetails.value.endTime = "";

  // Set default title based on type if title is empty
  if (!closureDetails.value.title.trim()) {
    switch (closureDetails.value.type) {
      case "closed":
        closureDetails.value.title = "School Closed";
        break;
      case "snow_day":
        closureDetails.value.title = "Snow Day";
        break;
      case "holiday":
        closureDetails.value.title = "Holiday";
        break;
      case "sick_day":
        closureDetails.value.title = "Sick Day";
        break;
      case "late_start":
        closureDetails.value.title = "Late Start";
        break;
      case "early_dismissal":
        closureDetails.value.title = "Early Dismissal";
        break;
    }
  }
};

// Fetch districts on component mount
onMounted(async () => {
  await fetchDistricts();
});

// Fetch districts from API
const fetchDistricts = async () => {
  isLoadingDistricts.value = true;
  try {
    const response = await fetch(`${API_URL}/districts`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    if (response.ok) {
      const data = await response.json();
      districts.value = data;
      filteredDistricts.value = data;
    } else {
      console.error("Failed to fetch districts:", response.statusText);
    }
  } catch (error) {
    console.error("Error fetching districts:", error);
  } finally {
    isLoadingDistricts.value = false;
  }
};

// Filter districts based on search input
const filterDistricts = () => {
  if (!districtSearch.value.trim()) {
    filteredDistricts.value = districts.value;
    return;
  }

  const searchTerm = districtSearch.value.toLowerCase();
  filteredDistricts.value = districts.value.filter((district) =>
    district.name.toLowerCase().includes(searchTerm)
  );
};

// Select a district
const selectDistrict = (district: District) => {
  selectedDistrict.value = district;
};

// Form validation
const validateForm = () => {
  const newErrors: FormErrors = {};

  if (!selectedDistrict.value) {
    newErrors.district = "Please select a district";
  }

  if (!closureDetails.value.title.trim()) {
    newErrors.title = "Title is required";
  }

  if (!closureDetails.value.type) {
    newErrors.type = "Type is required";
  }

  if (!closureDetails.value.startDate) {
    newErrors.startDate = "Start date is required";
  }

  if (
    closureDetails.value.endDate &&
    new Date(closureDetails.value.endDate) <
      new Date(closureDetails.value.startDate)
  ) {
    newErrors.endDate = "End date cannot be before start date";
  }

  // Validate time fields for late start and early dismissal
  if (
    closureDetails.value.type === "late_start" &&
    !closureDetails.value.startTime
  ) {
    newErrors.startTime = "Start time is required for late start";
  }

  if (
    closureDetails.value.type === "early_dismissal" &&
    !closureDetails.value.endTime
  ) {
    newErrors.endTime = "Dismissal time is required for early dismissal";
  }

  if (options.value.applyTo === "specificYear" && !options.value.academicYear) {
    newErrors.academicYear = "Please select an academic year";
  }

  errors.value = newErrors;
  return Object.keys(newErrors).length === 0;
};

// Submit the form
const submitForm = async () => {
  if (!validateForm()) {
    return;
  }

  isSubmitting.value = true;
  successMessage.value = "";

  try {
    // Prepare request payload with all necessary fields
    const payload = {
      closureDetails: {
        ...closureDetails.value,
        // If end date is not provided, use start date
        endDate: closureDetails.value.endDate || closureDetails.value.startDate,
      },
      options: {
        skipExistingClosures: options.value.skipExistingClosures,
      } as ClosureRequestOptions,
    };

    // Add academic year if specific year is selected
    if (
      options.value.applyTo === "specificYear" &&
      options.value.academicYear
    ) {
      payload.options.academicYear = options.value.academicYear;
    }

    if (selectedDistrict.value) {
      const response = await fetch(
        `${API_URL}/districts/${selectedDistrict.value.id}/closures`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        const result = await response.json();
        successMessage.value = `Successfully created closures for ${result.affectedCalendars} school calendars.`;

        // Reset form after successful submission
        closureDetails.value = {
          title: "",
          type: "",
          description: "",
          startDate: "",
          endDate: "",
          startTime: "",
          endTime: "",
          affectsAttendance: true,
        };
        selectedDistrict.value = null;
        districtSearch.value = "";
      } else {
        const errorData = await response.json();
        errors.value = {
          submit: errorData.message || "Failed to create district-wide closure",
        };
      }
    }
  } catch (error) {
    console.error("Error creating district-wide closure:", error);
    errors.value = { submit: "An unexpected error occurred" };
  } finally {
    isSubmitting.value = false;
  }
};

// Navigation
const goBack = () => {
  router.push("/districts");
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/" }, {
        default: _withCtx(() => [
          _createTextVNode("Home")
        ]),
        _: 1
      }),
      _createTextVNode(" / "),
      _createVNode(_component_router_link, { to: "/districts" }, {
        default: _withCtx(() => [
          _createTextVNode("Districts")
        ]),
        _: 1
      }),
      _createTextVNode(" / "),
      _hoisted_3
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((districtSearch).value = $event)),
              placeholder: "Search districts...",
              onInput: filterDistricts,
              class: "search-input"
            }, null, 544), [
              [_vModelText, districtSearch.value]
            ]),
            (isLoadingDistricts.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Loading... "))
              : _createCommentVNode("", true)
          ]),
          (filteredDistricts.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredDistricts.value, (district) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: district.id,
                    class: _normalizeClass(["district-item", {
                selected:
                  selectedDistrict.value && selectedDistrict.value.id === district.id,
              }]),
                    onClick: ($event: any) => (selectDistrict(district))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: "building",
                      class: "district-icon"
                    }),
                    _createTextVNode(" " + _toDisplayString(district.name) + " (" + _toDisplayString(district.organizations ? district.organizations.length : 0) + " schools) ", 1)
                  ], 10, _hoisted_12))
                }), 128))
              ]))
            : (!isLoadingDistricts.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, " No districts found "))
              : _createCommentVNode("", true)
        ])
      ]),
      (selectedDistrict.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _withDirectives(_createElementVNode("input", {
                id: "title",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((closureDetails.value.title) = $event)),
                placeholder: "e.g., Snow Day, Holiday, Teacher In-Service",
                required: ""
              }, null, 512), [
                [_vModelText, closureDetails.value.title]
              ]),
              (errors.value.title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(errors.value.title), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _withDirectives(_createElementVNode("select", {
                id: "type",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((closureDetails.value.type) = $event)),
                required: "",
                onChange: handleTypeChange
              }, _hoisted_28, 544), [
                [_vModelSelect, closureDetails.value.type]
              ]),
              (errors.value.type)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(errors.value.type), 1))
                : _createCommentVNode("", true)
            ]),
            (closureDetails.value.type)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: getEventTypeIcon(closureDetails.value.type),
                      class: _normalizeClass('icon-' + closureDetails.value.type)
                    }, null, 8, ["icon", "class"])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("strong", null, _toDisplayString(getEventTypeLabel(closureDetails.value.type)), 1),
                    _createElementVNode("p", null, _toDisplayString(getEventTypeDescription(closureDetails.value.type)), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (showTimeFields.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  (closureDetails.value.type === 'late_start')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _hoisted_35,
                        _withDirectives(_createElementVNode("input", {
                          id: "startTime",
                          type: "time",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((closureDetails.value.startTime) = $event)),
                          required: ""
                        }, null, 512), [
                          [_vModelText, closureDetails.value.startTime]
                        ]),
                        (errors.value.startTime)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(errors.value.startTime), 1))
                          : _createCommentVNode("", true),
                        _hoisted_37
                      ]))
                    : _createCommentVNode("", true),
                  (closureDetails.value.type === 'early_dismissal')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _hoisted_39,
                        _withDirectives(_createElementVNode("input", {
                          id: "endTime",
                          type: "time",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((closureDetails.value.endTime) = $event)),
                          required: ""
                        }, null, 512), [
                          [_vModelText, closureDetails.value.endTime]
                        ]),
                        (errors.value.endTime)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(errors.value.endTime), 1))
                          : _createCommentVNode("", true),
                        _hoisted_41
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _withDirectives(_createElementVNode("textarea", {
                id: "description",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((closureDetails.value.description) = $event)),
                placeholder: "Additional details about this closure",
                rows: "3"
              }, null, 512), [
                [_vModelText, closureDetails.value.description]
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _withDirectives(_createElementVNode("input", {
                  id: "startDate",
                  type: "date",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((closureDetails.value.startDate) = $event)),
                  required: ""
                }, null, 512), [
                  [_vModelText, closureDetails.value.startDate]
                ]),
                (errors.value.startDate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(errors.value.startDate), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _withDirectives(_createElementVNode("input", {
                  id: "endDate",
                  type: "date",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((closureDetails.value.endDate) = $event)),
                  min: closureDetails.value.startDate
                }, null, 8, _hoisted_50), [
                  [_vModelText, closureDetails.value.endDate]
                ]),
                (errors.value.endDate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(errors.value.endDate), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                _withDirectives(_createElementVNode("input", {
                  id: "affectsAttendance",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((closureDetails.value.affectsAttendance) = $event))
                }, null, 512), [
                  [_vModelCheckbox, closureDetails.value.affectsAttendance]
                ]),
                _hoisted_54
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _withDirectives(_createElementVNode("input", {
                  id: "skipExistingClosures",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((options.value.skipExistingClosures) = $event))
                }, null, 512), [
                  [_vModelCheckbox, options.value.skipExistingClosures]
                ]),
                _hoisted_57
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (selectedDistrict.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
            _hoisted_59,
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _withDirectives(_createElementVNode("input", {
                  id: "allCalendars",
                  type: "radio",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((options.value.applyTo) = $event)),
                  value: "all",
                  name: "applyTo"
                }, null, 512), [
                  [_vModelRadio, options.value.applyTo]
                ]),
                _hoisted_62
              ]),
              _createElementVNode("div", _hoisted_63, [
                _withDirectives(_createElementVNode("input", {
                  id: "specificYear",
                  type: "radio",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((options.value.applyTo) = $event)),
                  value: "specificYear",
                  name: "applyTo"
                }, null, 512), [
                  [_vModelRadio, options.value.applyTo]
                ]),
                _hoisted_64
              ])
            ]),
            (options.value.applyTo === 'specificYear')
              ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                  _hoisted_66,
                  _withDirectives(_createElementVNode("select", {
                    id: "academicYear",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((options.value.academicYear) = $event))
                  }, [
                    _hoisted_67,
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(academicYears, (year) => {
                      return _createElementVNode("option", {
                        key: year,
                        value: year
                      }, _toDisplayString(year), 9, _hoisted_68)
                    }), 64))
                  ], 512), [
                    [_vModelSelect, options.value.academicYear]
                  ]),
                  (errors.value.academicYear)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString(errors.value.academicYear), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_70, [
        _createElementVNode("button", {
          onClick: goBack,
          class: "btn-cancel"
        }, "Cancel"),
        _createElementVNode("button", {
          onClick: submitForm,
          class: "btn-submit",
          disabled: isSubmitting.value || !selectedDistrict.value
        }, _toDisplayString(isSubmitting.value
              ? "Creating..."
              : "Create District-Wide Schedule Change"), 9, _hoisted_71)
      ])
    ]),
    (successMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(successMessage.value), 1))
      : _createCommentVNode("", true),
    (errors.value.submit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_73, _toDisplayString(errors.value.submit), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})